import { render, staticRenderFns } from "./manage-missing-subtitles.vue?vue&type=template&id=12205e74&scoped=true"
import script from "./manage-missing-subtitles.vue?vue&type=script&lang=js"
export * from "./manage-missing-subtitles.vue?vue&type=script&lang=js"
import style0 from "./manage-missing-subtitles.vue?vue&type=style&index=0&id=12205e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12205e74",
  null
  
)

export default component.exports